import proj4 from 'proj4';

export function convertUTMToLatLong(easting, northing, zone) {
    // Definition of the UTM projection for zone 31N
    const utmProjection = `+proj=utm +zone=${zone} +datum=WGS84 +units=m +no_defs`;
    const wgs84Projection = '+proj=longlat +datum=WGS84 +no_defs';

    try {
        const convEasting = parseFloat(easting);
        const convNorthing = parseFloat(northing);
        if (isNaN(convEasting) || isNaN(convNorthing)) {
            return null;
        }
        const coordinates = proj4(utmProjection, wgs84Projection, [convEasting, convNorthing]);
        return {
            latitude: coordinates[1],
            longitude: coordinates[0]
        };
    } catch (error) {
        console.error('Erreur de conversion UTM:', error);
        return null;
    }
}

export function convertDMSToLatLong(latitude, longitude) {
    const lat = checkIfDMS(latitude);
    const lng = checkIfDMS(longitude);

    if (isNaN(lat) || isNaN(lng)) {
        return null;
    }
    return { latitude: lat, longitude: lng };
}

function checkIfDMS(dms) {
    if (typeof dms === "number") return dms; // already decimal
    const regex = /(\d+)[°\s]+(\d+)'?([\d.]*)"?\s*([NSEW])?/i;
    // const regex = /^(\d{1,3})°\s?(\d{1,2})'\s?(\d{1,2}(?:\.\d{1,})?)"?$/;
    const match = dms.match(regex);
    if (!match) return parseFloat(dms.replace(",", "."));

    const [, deg, min, sec, dir] = match;
    if (
        (deg >= 0) &&
        (min >= 0 && min < 60) &&
        (sec >= 0 && sec < 60)
    ) {
        let dec = parseFloat(deg) + parseFloat(min) / 60 + (parseFloat(sec) || 0) / 3600;
        if (dir === "S" || dir === "W") dec = -dec;
        return dec;
    }
    return 0;
}
